<template>
  <!-- 1. Spinner -->
  <div class="loading" v-if="isLoading && !noMatch">
    <base-spinner></base-spinner>
  </div>
  <!-- 2. Spinner -->
  <NoMatch v-if="noMatch === true" @toggle-match="handleCloseOneMineral" />
  <!-- 3. One Mineral -->
  <div class="content" v-if="!isLoading && !noMatch">
    <close-button @click="handleCloseOneMineral" mode="details"></close-button>
    <div class="title">
      <div class="title_name">
        <h1>{{ oneMineral.name }}</h1>
      </div>
      <div class="title_detail">{{ oneMineral.type.propValue }}</div>
    </div>

    <div class="left">
      <div class="left--photo">
        <base-photo
          :image-data="
            Object.assign(oneMineral, {
              size: 'mediumMineral',
              source: '/img/minerals/' + oneMineral.idName.replace(/\W/g, ''),
            })
          "
        />
      </div>
    </div>

    <div class="right content__text">
      <div class="content__text--details">
        <div class="details__item">
          <div class="details__item--1">{{ oneMineral.formula.propName }}:</div>
          <div
            class="details__item--2"
            v-html="oneMineral.formula.propValue"
          ></div>
        </div>
        <div class="details__item">
          <div class="details__item--1">{{ oneMineral.type.propName }}:</div>
          <div class="details__item--2">{{ oneMineral.type.propValue }}</div>
        </div>
        <div class="details__item">
          <div class="details__item--1">
            {{ oneMineral.composition.propName }}:
          </div>
          <div class="details__item--2">
            {{ oneMineral.composition.propValue }}
          </div>
        </div>
        <div class="details__item">
          <div class="details__item--1">{{ oneMineral.crystal.propName }}:</div>
          <div class="details__item--2">{{ oneMineral.crystal.propValue }}</div>
        </div>
        <div class="details__item">
          <div class="details__item--1">
            {{ oneMineral.cleavage.propName }}:
          </div>
          <div class="details__item--2">
            {{ oneMineral.cleavage.propValue }}
          </div>
        </div>
        <div class="details__item">
          <div class="details__item--1">
            {{ oneMineral.fracture.propName }}:
          </div>
          <div class="details__item--2">
            {{ oneMineral.fracture.propValue }}
          </div>
        </div>
        <div class="details__item">
          <div class="details__item--1">{{ oneMineral.lustre.propName }}:</div>
          <div class="details__item--2">{{ oneMineral.lustre.propValue }}</div>
        </div>
        <div class="details__item">
          <div class="details__item--1">{{ oneMineral.streak.propName }}:</div>
          <div class="details__item--2">{{ oneMineral.streak.propValue }}</div>
        </div>
        <div class="details__item">
          <div class="details__item--1">
            {{ oneMineral.hardness.propName }}:
          </div>
          <div class="details__item--2">
            {{ oneMineral.hardness.propValue[0] }}
            {{
              oneMineral.hardness.propValue[1] == "-1"
                ? ""
                : `- ${oneMineral.hardness.propValue[1]}`
            }}
          </div>
        </div>
        <div class="details__item">
          <div class="details__item--1">{{ oneMineral.density.propName }}:</div>
          <div class="details__item--2">
            {{ oneMineral.density.propValue[0] }}
            {{
              oneMineral.density.propValue[1] == "-1"
                ? ""
                : `- ${oneMineral.density.propValue[1]}`
            }}
            g/cm<sup>3</sup>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import NoMatch from "@/components/finder/NoMatch.vue";
import BasePhoto from "@/components/ui/BasePhoto.vue";

import { computed, onBeforeMount, ref } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";

onBeforeMount(() => {
  getBasePage();
});

const store = useStore();
const route = useRoute();
const router = useRouter();

const isLoading = ref(false);
/**
 * listen to params and get oneRock data
 */
async function getBasePage() {
  isLoading.value = !isLoading.value;
  await store.dispatch("minerals/getMineralFromParams", route.params.mineralId);
  isLoading.value = !isLoading.value;
}
/**
 * get Mineral data
 */
const oneMineral = computed(() => {
  return store.getters["minerals/getOneMineral"];
});

/**
 * No Match
 */
const noMatch = computed(() => {
  return store.getters["minerals/getNoMatch"];
});
/**
 * Return to all minerals
 */

function handleCloseOneMineral() {
  router.push("/minerals");
}
</script>

<style lang="css" scoped>
.content {
  position: relative;
  margin-top: -5vh;
  display: grid;
  /* grid-template-rows: 22vh 78vh; */
  grid-template-rows: 25vh 60vh;
  grid-template-columns: 1fr 1fr;
  width: 90vw;
  height: 95vh;
  background-color: oklch(96.2% 0.018 272.314);
  color: var(--color-grey-4);
  z-index: 1500;
}
/* 600px */
@media only screen and (max-width: 37.5em) {
  .content {
    padding-top: 7rem;
    display: flex;
    flex-direction: column;
    height: auto;
  }
}

.title {
  grid-row: 1/2;
  grid-column: 1/-1;

  text-align: center;
  align-content: end;
}

.title_name {
  font-family: var(--font-display);
  text-transform: uppercase;
  font-size: 6rem;
}
/* 760px */
@media only screen and (max-width: 47.5em) {
  .title_name {
    font-size: 4rem;

    font-style: normal;
    font-weight: 100;
  }
}
/* 600px */
@media only screen and (max-width: 600px) {
  .title_name {
    text-transform: capitalize;
    font-size: 1rem;
  }
}

.title_detail {
  font-family: var(--font-primary);
  font-size: 4rem;
  text-transform: capitalize;
}
.left {
  grid-row: 2/2;
  grid-column: 1/2;
  display: grid;
  grid-template-rows: 1fr 3fr 2fr;
}
/* 600px */
@media only screen and (max-width: 37.5em) {
  .left {
    display: flex;
    justify-content: center;
  }
}

.left--photo {
  grid-row: 2/3;
  display: flex;
  align-items: center;
  justify-content: center;
}
.left--details {
  grid-row: 3/4;
  font-size: 2.5rem;

  padding-top: 2rem;
  text-align: center;
}

.right {
  grid-row: 2/3;
  grid-column: 2/3;
  display: flex;
  flex-direction: column;
  gap: 2rem;
  padding: 3rem;
}

/* 1300px */
@media only screen and (max-width: 81.25em) {
  .right {
    margin-top: 5rem;
  }
}
/* 1025px */
@media only screen and (max-width: 64em) {
  .right {
    margin-top: 10rem;
  }
}
/* 600px */
@media only screen and (max-width: 37.5em) {
  .right {
    margin-top: 0px;
  }
}

.content__text {
  grid-column: 2/3;
  margin: 3.5rem;
  position: relative;
  font-size: 1.8rem;
  color: var(--color-grey-4);
  text-align: center;
}
@media only screen and (max-width: 56.25em) {
  .content__text {
    margin: 4rem;
    font-size: 2.5rem;
  }
}
@media only screen and (max-width: 35em) {
  .content__text {
    margin: 2rem;
    grid-column: 1 / -1;
    grid-row: 2 / 3;
  }
}
.content__text--heading {
  text-align: center;
  align-self: center;
  text-transform: capitalize;
}
.content__text--details {
  margin: 4rem 1.5rem;
  font-weight: 900;
}
.details__item {
  display: flex;
  flex-direction: row;
}
.details__item--1 {
  text-transform: capitalize;
  width: 40%;
}
.details__item--2 {
  text-align: left;
  width: 60%;
  border-bottom: 1px solid var(--color-primary-3);
}
</style>
